// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { jwtDecode } from 'jwt-decode';

/** 获取当前的用户  */
export async function currentUser() {
  const token = window.localStorage.getItem('token');
  return jwtDecode<API.CurrentUser>(token ?? '');
}

/** 退出登录 */
export async function outLogin() {
    window.localStorage.setItem('token', '');
}
